import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { useCountry } from "../context/CountryContext";

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const { isGhana, config, resetCountry } = useCountry();

  // ✅ Check login state
  const user = JSON.parse(localStorage.getItem("user"));
  const admin = JSON.parse(localStorage.getItem("adminUser"));

  // 🎨 THEME PER COUNTRY
  const theme = isGhana
    ? {
        navBg: "bg-gradient-to-r from-yellow-50 to-red-50",
        logoText: "text-red-700",
        brandName: "ProBank Ghana",
        linkColor: "text-gray-800 hover:text-red-700",
        flag: "🇬🇭",
        mobileBg: "bg-yellow-50",
        mobileLinkHover: "hover:bg-yellow-100",
      }
    : {
        navBg: "bg-white",
        logoText: "text-gray-900",
        brandName: "Probank 15v",
        linkColor: "text-gray-700 hover:text-black",
        flag: "🇳🇬",
        mobileBg: "bg-white",
        mobileLinkHover: "hover:bg-gray-100",
      };

  const handleLogout = () => {
    if (admin) {
      localStorage.removeItem("adminUser");
      localStorage.removeItem("adminToken");
      window.location.href = "/admin-login";
    } else {
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      window.location.href = "/login";
    }
  };

  const handleSwitchCountry = () => {
    if (window.confirm("Switch country? You'll need to pick again on the country selector page.")) {
      resetCountry();
      window.location.href = "/";
    }
  };

  const location = useLocation();

  // ✅ Pages where Navbar should NOT show
  const hideNavbarPages = [
    "/",
    "/moneypoint",
    "/opay",
    "/pampay",
    "/cuda",
    "/luno-dashboard",
    "/transfer-opay",
    "/transfer-bank",
    "/send-bank",
    "/send-palmpay",
    "/landinpage",
  ];

  if (hideNavbarPages.includes(location.pathname)) return null;

  return (
    <nav className={`fixed top-0 left-0 w-full ${theme.navBg} shadow-md z-50`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex-shrink-0 flex items-center">
            <img
              src="/banklogo.png"
              alt={theme.brandName}
              className="h-8 w-auto"
            />
            <span className={`ml-2 font-bold text-lg ${theme.logoText}`}>
              {theme.brandName}
            </span>
            <span className="ml-2 text-sm">{theme.flag}</span>
          </div>

          {/* Mobile menu button */}
          <div className="flex md:hidden items-center gap-2">
            <span className="text-xs text-gray-500">{config.name}</span>
            <button
              onClick={() => setMenuOpen(!menuOpen)}
              className="text-gray-700 hover:text-black focus:outline-none text-xl"
            >
              ☰
            </button>
          </div>

          {/* Desktop menu */}
          <div className="hidden md:flex items-center space-x-6">
            <a href="/home" className={theme.linkColor}>
              Home
            </a>

            {user && !admin && (
              <>
                <a href="/dashboard" className={theme.linkColor}>
                  Dashboard
                </a>
                <button
                  onClick={handleSwitchCountry}
                  className={`${theme.linkColor} text-sm`}
                  title="Switch country"
                >
                  {theme.flag} Switch
                </button>
                <button
                  onClick={handleLogout}
                  className="text-red-600 hover:text-red-800"
                >
                  Logout
                </button>
              </>
            )}

            {admin && (
              <>
                <a href="/admin/overview" className={theme.linkColor}>
                  Admin Dashboard
                </a>
                <button
                  onClick={handleLogout}
                  className="text-red-600 hover:text-red-800"
                >
                  Logout
                </button>
              </>
            )}

            {!user && !admin && (
              <>
                <a href="/login" className={theme.linkColor}>
                  User Login
                </a>
                <a href="/admin-login" className={theme.linkColor}>
                  Admin Login
                </a>
                <button
                  onClick={handleSwitchCountry}
                  className={`${theme.linkColor} text-sm`}
                >
                  {theme.flag} Change Country
                </button>
              </>
            )}
          </div>
        </div>
      </div>

      {/* Mobile dropdown menu */}
      {menuOpen && (
        <div className={`md:hidden ${theme.mobileBg} shadow-md`}>
          <a
            href="/home"
            className={`block px-4 py-2 ${theme.linkColor.replace("hover:", "")} ${theme.mobileLinkHover}`}
          >
            Home
          </a>

          {user && !admin && (
            <>
              <a
                href="/dashboard"
                className={`block px-4 py-2 ${theme.linkColor.replace("hover:", "")} ${theme.mobileLinkHover}`}
              >
                Dashboard
              </a>
              <button
                onClick={handleSwitchCountry}
                className={`block w-full text-left px-4 py-2 ${theme.linkColor.replace("hover:", "")} ${theme.mobileLinkHover}`}
              >
                {theme.flag} Switch Country
              </button>
              <button
                onClick={handleLogout}
                className={`block w-full text-left px-4 py-2 text-red-600 ${theme.mobileLinkHover}`}
              >
                Logout
              </button>
            </>
          )}

          {admin && (
            <>
              <a
                href="/admin/overview"
                className={`block px-4 py-2 ${theme.linkColor.replace("hover:", "")} ${theme.mobileLinkHover}`}
              >
                Admin Dashboard
              </a>
              <button
                onClick={handleLogout}
                className={`block w-full text-left px-4 py-2 text-red-600 ${theme.mobileLinkHover}`}
              >
                Logout
              </button>
            </>
          )}

          {!user && !admin && (
            <>
              <a
                href="/login"
                className={`block px-4 py-2 ${theme.linkColor.replace("hover:", "")} ${theme.mobileLinkHover}`}
              >
                User Login
              </a>
              <a
                href="/admin-login"
                className={`block px-4 py-2 ${theme.linkColor.replace("hover:", "")} ${theme.mobileLinkHover}`}
              >
                Admin Login
              </a>
              <button
                onClick={handleSwitchCountry}
                className={`block w-full text-left px-4 py-2 ${theme.linkColor.replace("hover:", "")} ${theme.mobileLinkHover}`}
              >
                {theme.flag} Change Country
              </button>
            </>
          )}
        </div>
      )}
    </nav>
  );
}

export default Navbar;
